import { useLang } from '@/i18n';
import XCore from '@elem/SVGIcon/FourInOne/XCore';
import EfBanner from '@elem/ui/ef-banner';

import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('fourinone.teaser');

    const itemA = {
        label: (
            <div className="BannerA-label">
                {t('banner_label')}
                <XCore color="black" />
            </div>
        ),
        title: t('banner_title'),
        desc: t('banner_desc'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724124061484/kv_banner.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724138727906/kv_banner_h5.jpg',
        theme: 'black',
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...itemA} />
        </div>
    );
}
